import { render, staticRenderFns } from "./HsabExpenseFormExpenseCategory.vue?vue&type=template&id=2adbb490&scoped=true"
import script from "./HsabExpenseFormExpenseCategory.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseFormExpenseCategory.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseFormExpenseCategory.vue?vue&type=style&index=0&id=2adbb490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbb490",
  null
  
)

export default component.exports